import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { FeatureToggleEnum } from '@mwe/constants';
import { ProfileService } from '@mwe/services';

@Directive({ selector: '[mweIsFeatureDisabled]' })
export class IsFeatureDisabledDirective {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private profileService = inject(ProfileService);

  private hasView = false;

  @Input() set mweIsFeatureDisabled(toggle: FeatureToggleEnum) {
    const isDisabled = this.profileService.isFeatureToggleDisabled(toggle);

    if (isDisabled && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isDisabled && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
